module.exports = __webpack_public_path__ + "img/direccion-o-d-duo.d2ccd337.png";